import { configureStore } from "@reduxjs/toolkit"
import appGlobalReducer from "./appGlobal"
import commonReducer from "./common"
import roleReducer from "./role"
import hrReducer from "./hr"
import crmReducer from "./crm"
import crmMobileReducer from "./crmMobile"
import crmCallingReducer from "./crmCallingReducer"
import provinceReducer from "./provinceSlice"
import vehicleReducer from "./vehicleSlice"
import giftReducer from "./giftSlice"

export default configureStore({
  reducer: {
    appGlobal: appGlobalReducer,
    role: roleReducer,
    common: commonReducer,
    hr: hrReducer,
    crm: crmReducer,
    crmMobile: crmMobileReducer,
    calling: crmCallingReducer,
    province: provinceReducer,
    vehicle: vehicleReducer,
    gift: giftReducer,
  },
})
